import { NodeProps as ReactNodeProps } from 'reactflow';
import { ComponentType, ElementType } from 'react';
import { WorkflowNode, WorkflowNodeType } from 'api/model.ts';

export type MenuItems = {
  items: MenuItem[];
};

export type SingleMenuItem = {
  id: string;
  title: string;
  type: string;
  url: string;
  icon: ElementType;
  breadcrumbs: boolean;
};

export type MenuItem = {
  id: string;
  title: string;
  type: string;
  children: SingleMenuItem[];
};

type OptionalNodeProps = {
  name?: string;
};

export type NodeProps = ReactNodeProps<WorkflowNode> & OptionalNodeProps;

export type NodeTypes = Record<WorkflowNodeType, ComponentType<NodeProps>>;

export enum WorkflowExecutionStatusEnum {
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  RUNNING = 'RUNNING',
  CANCELLED = 'CANCELLED',
}

export enum ExecutionNodeStatusEnum {
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_WARNINGS = 'COMPLETED_WITH_WARNINGS',
  NEW = 'NEW',
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  DISABLED = 'DISABLED',
}

export type SortDirection = '' | '-';
